import React from 'react'

import Image, { ImageProps } from 'next/image'
import { imageContainerResponsive } from './styles/imageResponsive.css'

export interface ImageResponsiveProps extends ImageProps {
  src: string
  alt: string
  blurSrc?: string
  errorSrc?: string
  blur?: boolean
  priority?: boolean
  sizes?: string
  containerClassName?: string
}

export const ImageResponsive: React.FC<ImageResponsiveProps> = ({
  src,
  alt,
  errorSrc,
  blurSrc,
  blur = false,
  priority,
  sizes = '100%, 100%',
  className = '',
  containerClassName = '',
  ...rest
}) => {
  const [source, setSource] = React.useState(src)
  return (
    <div className={`${imageContainerResponsive} ${containerClassName}`}>
      <Image
        src={source}
        alt={alt}
        placeholder={blur ? 'blur' : 'empty'}
        blurDataURL={blurSrc ? blurSrc : source}
        sizes={sizes}
        fill={true}
        className={`image-responsive ${className}`}
        priority={priority}
        onError={() => setSource(errorSrc ? errorSrc : source)}
        {...rest}
      />
    </div>
  )
}
